import { postRequest } from 'components/Common/Utils';
import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Button, Label, Input,
    Form,
    Spinner,
} from "reactstrap";

const OrderGraphAnalytics = () => {


    const [inputData, setInputData] = useState({
        period: "current-month",
        interval: "day",
        dateStart: "",
        dateEnd: "",
    });

    const [chartData, setChartData] = useState({
        series: [
            {
                name: 'Order Count',
                type: 'column',
                data: []
            },
            {
                name: 'Total Amount',
                type: 'line',
                data: []
            }
        ],
        options: {
            chart: {
                height: 350,
                type: 'line',
            },
            stroke: {
                width: [0, 3],
                curve: 'smooth',
            },
            plotOptions: {
                bar: {
                    columnWidth: '30%',
                    borderRadius: 5,
                },
            },
            fill: {
                // opacity: [0.2, 1],
            },
            xaxis: {
                type: 'category',
                categories: [],
            },
            yaxis: [
                {
                    title: {
                        text: 'Order Count',
                    },
                },
                {
                    opposite: true,
                    title: {
                        text: 'Total Amount',
                    },
                },
            ],
            legend: {
                position: 'top',
                horizontalAlign: 'left',
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (y) {
                        if (typeof y !== 'undefined') {
                            // return `${y.toFixed(0)} units`;
                            return `${y.toFixed(0)} `;
                        }
                        return y;
                    },
                },
            },
        },
    });

    const fetchOrderGraphList = async () => {
        try {
            const res = await postRequest('analytics/order-graph', inputData);
            if (res.status) {
                const { datasets, labels, totals } = res.data;

                setChartData({
                    ...chartData,
                    series: [
                        {
                            name: 'Order Count',
                            type: 'column',
                            data: datasets,
                        },
                        {
                            name: 'Total Amount',
                            type: 'line',
                            data: totals,
                        }
                    ],
                    options: {
                        ...chartData.options,
                        xaxis: {
                            ...chartData.options.xaxis,
                            categories: labels,
                        },
                    },
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchOrderGraphList();
    }, []);

    const updateGrpah = () => {
        fetchOrderGraphList()
    }
    const updateInput = (target, value) => {
        setInputData({
            ...inputData,
            [target]: value
        })
        fetchOrderGraphList();
        if (value === 'custom-date') {
            setLastPeriod(inputData.period);
            setShowModel(true);
        }
    }

    return (
        <div className="chart-container">
            <Row className="align-items-center mb-3" style={{ justifyContent: 'end' }}>
                <Col md={8}>
                    <h3>Order Transaction Insights</h3>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label for="period">Period</Label>
                        <Input
                            type="select"
                            id="period"
                            value={inputData.period}
                            onChange={e => updateInput('period', e.target.value)}
                        >
                            <option value="current-month">Current Month</option>
                            <option value="current-year">Current Year</option>
                            <option value="last-30-days">Last 30 Days</option>
                            <option value="last-12-month">Last 12 Months</option>
                            <option value="previous-month">Previous Month</option>
                            <option value="previous-year">Previous Year</option>
                            {/* <option value="custom-date">Custom Date</option> */}
                        </Input>
                    </FormGroup>
                </Col>

                <Col md={1}>
                    <Button type="button" color="primary" style={{ marginTop: "24px" }} block>Submit</Button>
                </Col>
            </Row>
            <Chart
                options={chartData.options}
                series={chartData.series}
                type="line"
                height={350}
            />
        </div>
    );
};

export default OrderGraphAnalytics;
